/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */

import Swiper from 'swiper';
import { Autoplay, EffectCards, EffectCoverflow, EffectCube, EffectFade, EffectFlip } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-cards';
import 'swiper/css/effect-coverflow';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-flip';

document.addEventListener( 'DOMContentLoaded', () => {

    const swipers = document.querySelectorAll('.swiper');

    if(!!swipers && swipers.length > 0){    

        swipers.forEach(swiper => {
            const interval = parseInt(swiper.dataset.interval) * 1000 || 3000;
            const transition = swiper.dataset.transition || 'fade';
            
            new Swiper(swiper, {
                modules: [Autoplay, EffectCards, EffectCoverflow, EffectCube, EffectFade, EffectFlip],
                effect: transition,
                autoplay: {
                    delay: interval,
                },
            });
        });
    }

});

/* eslint-enable no-console */
